module.exports = __webpack_public_path__ + "img/acceso_rapido.b2165f57.jpg";